<template>
  <ElTabs :key="activeName.key" v-model="activeName.nav" type="card">
    <ElTabPane label="常见病调理">
      <span slot="label" class="tab-item">常见病调理</span>
      <DiseasesHealth :masseur-level="masseurLevel" />
    </ElTabPane>
    <ElTabPane label="亚健康调理">
      <DiseasesHealth :masseur-level="masseurLevel" :type="'health'" />
    </ElTabPane>
    <ElTabPane label="理疗项目"><Physiotherapy /></ElTabPane>
    <ElTabPane label="特色项目">
      <SpecialItems :masseur-level="masseurLevel" />
    </ElTabPane>
    <ElTabPane label="产品"><Product /></ElTabPane>
  </ElTabs>
</template>

<script>
import {menusNavigation} from '@/store';
import DiseasesHealth from '@/components/project/DiseaseHealth.vue';
import SpecialItems from '@/components/project/SpecialItems.vue';
import Product from '@/components/project/Product.vue';
import Physiotherapy from '@/components/project/Physiotherapy.vue';

export default {
  name: 'Project',
  components: {
    DiseasesHealth,
    SpecialItems,
    Product,
    Physiotherapy
  },
  props: {
    activeName: {
      type: Object,
      default: () => ({
        nav: '0'
      })
    }
  },
  data() {
    return {
      menusNavigation,
      masseurLevel: []
    };
  },

  mounted() {
    this.getMasseurLevel();
  },

  methods: {
    getMasseurLevel() {
      this.$http.post('/api/masseur/index/getMasseurLevel').then(res => {
        this.masseurLevel = res.map(item => item.id);
      });
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/css/util.scss';
.ProjectManage {
  .input {
    width: 90px;
    margin-right: 2px;
    input {
      text-align: center;
    }
  }
  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #4b90ff;
    color: #fff;
    .el-button {
      background-color: transparent;
      color: #fff;
      border-color: #fff;
    }
  }
  .el-table {
    &.noMembers {
      th {
        background-color: #fff;
      }
      padding-top: 20px;
    }
    th {
      background-color: #f3f4f6;
    }
  }
  .el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: #f6f8fd;
  }
  .el-table--striped .el-table__body tr.el-table__row--striped:hover td {
    background-color: #4b90ff;
  }
  @import '@/assets/css/tab.scss';
}
</style>
